import { Locale } from 'antd/es/locale'
import roRo from 'antd/locale/ro_RO'
import ruRU from 'antd/locale/ru_RU'

type Props = {
  label: string
  value: 'ro' | 'ru'
  systemValue: Locale
  icon: string
}

export const allLangs: Props[] = [
  {
    label: 'Română',
    value: 'ro',
    systemValue: roRo,
    icon: 'ro.svg'
  },
  {
    label: 'Русский',
    value: 'ru',
    systemValue: ruRU,
    icon: 'ru.svg'
  }
]

export const defaultLang = allLangs[0] // Română
